import "bootstrap-icons/font/bootstrap-icons.css";
import { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Navbar, NavbarBrand } from "reactstrap";

//App
import Logo from "../../assets/images/logo.png";
import { Auth } from "../../Auth/authProvider";
import AppBar from "../../components/AppBar/AppBar";
import { vfxTheme } from "../../components/common/VFX-UI/Theme/theme";

type HeaderProps = {
    environmentName?: string;
    displayEnvironmentBar?: boolean;
    showSideNavigation?: boolean;
};

const Header = (props: HeaderProps) => {
    
    const auth = useContext(Auth);
    return (
        <header>
            <div
                className="navbar-header navbar-sticky navbar-expand-sm navbar-toggleable-sm ng-white border-bottom header-box-shadow mb-3"
                style={{ zIndex: vfxTheme.drawer.zIndex - 1 }}
            >
                {props.displayEnvironmentBar && (
                    <Container className="header environment-bar">
                        <Row>
                            <Col xl={3} lg={4} md={6} sm={12} className="environment-col">
                                {props.environmentName}
                            </Col>
                            <Col
                                xl={3}
                                lg={4}
                                md={6}
                                className="d-none d-md-block environment-col"
                            >
                                {props.environmentName}
                            </Col>
                            <Col xl={3} lg={4} className="d-none d-lg-block environment-col">
                                {props.environmentName}
                            </Col>
                            <Col xl={3} className="d-none d-xl-block environment-col">
                                {props.environmentName}
                            </Col>
                        </Row>
                    </Container>
                )}
                <Navbar className="header light">
                    <NavbarBrand to="/">
                        <div>
                            <img src={Logo} alt="" className="img-fluid header-logo" />
                        </div>
                    </NavbarBrand>
                    {auth && auth.isAuthenticated() && (
                        <AppBar showSideNavigation={props.showSideNavigation} />
                    )}
                </Navbar>
            </div>
        </header>
    );
};

export default Header;
